<script>
export default {
  name: 'ItineraryPricesPriceSettingsSupplierModal',
  props: {
    suppliers: {
      type: Array,
      required: true,
    },
    selectedSupplier: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      localSelectedSupplier: null,
      dialog: false,
    };
  },
  watch: {
    selectedSupplier: {
      deep: true,
      immediate: true,
      handler(value) {
        this.updateSelectedSupplier(value);
      },
    },
  },
  methods: {
    updateSelectedSupplier(supplier) {
      if (this.localSelectedSupplier) {
        if (this.localSelectedSupplier.currency !== supplier.currency) {
          this.$emit('reset-prices');
        }
      }
      this.localSelectedSupplier = supplier;
    },
    save() {
      if (typeof (this.localSelectedSupplier) === 'undefined') {
        this.$emit('update', null);
      } else {
        this.$emit('update', this.localSelectedSupplier);
      }
      this.dialog = false;
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="blue lighten-2"
          icon
          flat
        >
          <div v-if="selectedSupplier">
            {{ localSelectedSupplier.currency }}
          </div>
          <div v-else>None</div>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Suppliers
        </v-card-title>

        <v-container>
          <v-autocomplete
            @change="updateSelectedSupplier"
            :items="suppliers"
            :value="localSelectedSupplier"
            item-text="name"
            item-value="id"
            label="Select supplier"
            clearable
            solo
            class="mr-2"
            return-object
          />
        </v-container>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="save" color="primary">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsSupplierModal.vue